export const Colors = {
  PRIMARY_GREEN: '#616449',
  PRIMARY_GREEN_DARKER: '#4c4e39',
  PRIMARY_GREEN_LIGHTER: '#787c5b',
  PRIMARY_DARK: '#333'
};
